import {URL_API_CSAT_FORM_SUBMIT, URL_API_CSAT_FORM_SEARCH, URL_API_CSAT_FORM_SCORE_CALCULATION, URL_API_CSAT_FORM_SEARCHTEMPLATE, URL_API_CSAT_FORM_SEARCH_COMPLETED} from '../apiHitFile';
import {showModalLogin} from '../Dashboard/UserActions';
import _ from 'lodash';
export function SubmitCSATForm(prop){
  return (dispatch, getState) => {
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_CSAT_FORM_SUBMIT, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(prop)
    }).then((res) => res.json())
      .then(json =>  dispatch(SearchInformationError(json)))
      .catch(error => dispatch(SearchInformationError(error)))
  }
}
export function SearchInformation(request){
  let url = URL_API_CSAT_FORM_SEARCH 
  return (dispatch, getState) => {
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization",currentToken);
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(url, {
      method: 'POST',
      headers : headers,
      body: JSON.stringify(request)
    })
    .then(res=>res.json())
    .then(json => {
      if(json.status === 403){
        dispatch(showModalLogin(json))
      } else {
         dispatch(SearchInformationSuccess(json))
      }})
    .catch(error => console.log(error))
    }
}
export function SearchInformationSuccess(data){
  if(!_.isEmpty(data.value)){
  return {
      type: "CSAT_SEARCH_DATA",
      userData:data.value
    }
  } else {
    return {
      type: "CSAT_ERROR",
      showerror:true, 
      errmessage:data.message
    }
  }
}
export function ResetUserData(){
  return {
    type: "CSAT_SEARCH_DATA",
    userData:{}
  }
}
export function SearchTepmlateInformation(prop){
  return (dispatch, getState) => {
    let headers = new Headers()    
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_CSAT_FORM_SEARCHTEMPLATE, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(prop)
    }).then((res) => res.json())
      .then(json => dispatch(SearchTepmlateInformationSuccess(json)))      
      .catch(error => dispatch(SearchInformationError(error)))
     }
}
export function SearchTepmlateInformationSuccess(data){
  if(!_.isNull(data.value) && data.status === 1001){
  return {
      type: "CSAT_SEARCH_TEMPLATE",
    template:data.value
    }
  } else {
    return {
      type: "CSAT_ERROR",
      showerror:true, 
      errmessage:"Template Not Mapped"
    }
  }
}
export function resetTemplate(){
  return {
    type: "CSAT_SEARCH_TEMPLATE_RESET",
    template:[]
  }
}
export function CSATSearchCompleted(prop){
  return (dispatch, getState) => {
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_CSAT_FORM_SEARCH_COMPLETED, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(prop)
    }).then((res) => res.json())
      .then(json => dispatch(CSATSearchCompletedSuccess(json))) 
      .catch(error => dispatch(SearchInformationError(error)))
     }
}
export function ScoreCalculation(id){
  return (dispatch, getState) => {  
    let userName = getState().LoginReducer.loginAction.userName;
    let headers = new Headers()    
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_CSAT_FORM_SCORE_CALCULATION, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(id,userName)
    }).then((res) => res.json())     
    .then(json => dispatch(ScoreCalculationSuccess(json)))    
    .catch(error => dispatch(SearchInformationError(error)))
  }
}
export function ScoreCalculationSuccess(data){
  if(!_.isEmpty(data)){
    return{
        type:"CSAT_COMPLETED_SCORES",
        ScoreCalculation:data
    }
  } else {
    return{
      type:"CSAT_ERROR",
      showerror: true,
      errmessage: data.message,
      isPending:false
    }
  }
}
export function CSATSearchCompletedSuccess(data){
  if(data.status === 200){
  return {
    type: "CSAT_SEARCH_COMPLETED",
    searchData:data.value
    }
  } else {
    return {
      type: "CSAT_ERROR",
      showerror:true, 
      errmessage:data.error
    }
  }
}
export function SearchInformationError(data){
  return {
    type: "CSAT_ERROR",
    showerror:true, 
    errmessage:data.error ? data.error : data.message
  }
}
export function closeModalPopUp(){
  return{
    type:'CSAT_MODAL_CLOSE',
    showerror:false
  }
}


